// extracted by mini-css-extract-plugin
export default {"accordion":"Accordian_accordion__w5Leo","panel":"Accordian_panel__7YvW2"};